export const orderStatus = Object.freeze({
  1: { value: "draft", color: "#A9A9A9" },
  2: { value: "incompleteData", color: "#FF4500" },
  3: { value: "awaitingSelection", color: "#1E90FF" },
  4: { value: "pendingPickup", color: "#D9880E" },
  5: { value: "pickUpStarted", color: "#f8b0d5" },
  6: { value: "arrivedAtPickup", color: "#FFD700" },
  7: { value: "orderCollected", color: "#00CED1" },
  8: { value: "orderOutForDelivery", color: "#FFB4A7" },
  9: { value: "arrivedAtDropOff", color: "#4682B4" },
  10: { value: "delivered", color: "#34A853" },
  11: { value: "cancelled", color: "#D71314" },
  12: { value: "rejected", color: "#00398F" },
  13: { value: "onHold", color: "#FF8C00" },
  14: { value: "rescheduled", color: "#91cfde" },
  15: { value: "returned", color: "#8A2BE2" },
  16: { value: "failed", color: "#B22222" },
  17: { value: "requestDriverChange", color: "#f26ab0" },
  18: { value: "driverChangeApproved", color: "#34A853" },
  19: { value: "conversationFailed", color: "#D71314" },
  22: { value: "driverChangeRejected", color: "#D71314" },
});

export const userTypes = Object.freeze({
  0: "receiver",
  1: "driver",
  2: "sender",
  3: "admin",
});

export const tableActionsEnum = Object.freeze({
  view: "view",
  cancel: "cancel",
});

export const businessTypes = Object.freeze({
  1: "retailers",
  2: "manufacturers",
  3: "wholesalersDistributors",
  4: "eCommercePlatforms",
  5: "healthcarePharmaceutical",
  6: "logisticsTransportation",
  7: "serviceBased",
});

export const registrationStatus = Object.freeze({
  1: "registered",
  2: "pending",
  3: "pendingForApproval",
  4: "active",
});

export const genderEnum = Object.freeze({
  1: "male",
  2: "female",
});

export const educationEnum = Object.freeze({
  1: "preparatory",
  2: "secondary",
  3: "bachelor",
});

export const driverRequestStatus = Object.freeze({
  0: "pending",
  1: "approved",
  2: "rejected",
});

export const driverRequestReasons = Object.freeze({
  0: "accident",
  1: "vehicleBrokeDown",
  2: "personalIssues",
});

export const mimeTypes = Object.freeze({
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  pdf: "application/pdf",
  png: "image/png",
});

export const fileTypeEnum = Object.freeze({
  1: "profilePicture",
  2: "identificationImageFront",
  3: "identificationImageBack",
  4: "driverLicence",
  5: "nonCriminalRecord",
  6: "tradeLicense",
  7: "registrationCertificate",
  8: "iconImage",
  9: "logoImage",
  10: "vatNumber",
  11: "driverChangeRequestAttachment",
  12: "vehicleLicense",
});

export const driverStatus = Object.freeze({
  1: "driverChange",
  2: "deliveryFailure",
});

export const cardConfig = Object.freeze([
  { title: "totalOrders", color: "#2A3467", iconKey: "threeBoxes", span: 2 },
  { title: "activeOrders", color: "#2A3467", iconKey: "packageIcon", span: 2 },
  {
    title: "completedOrders",
    color: "#34A853",
    iconKey: "completedTruck",
    span: 1,
  },
  {
    title: "incompleteOrders",
    color: "#DD6A57",
    iconKey: "incompleteOrders",
    span: 1,
  },
  {
    title: "activeDrivers",
    color: "#0A1D35",
    iconKey: "ActiveTruckIcon",
    span: 1,
  },
  {
    title: "rescheduledOrders",
    color: "#455A64",
    iconKey: "calenderIcon",
    span: 1,
  },
  {
    title: "unAssignedOrders",
    color: "#D71718",
    iconKey: "unAssigIcon",
    span: 1,
  },
]);

export const IssueTypeEnum = Object.freeze({
  0: { value: "pendingOrder", color: "#D9880E", iconKey: "pendingOrder" },
  1: {
    value: "delayedDelivery",
    color: "#FF4500",
    iconKey: "delayedDelivery",
  },
  2: { value: "delayedPickup", color: "#1E90FF", iconKey: "delayedPickup" },
  3: {
    value: "pendingRescheduledOrder",
    color: "#2A3467",
    iconKey: "pendingRescheduledorder",
  },
  4: {
    value: "driverChangeRequest",
    color: "#f8b0d5",
    iconKey: "driverChangeRequest",
  },
  5: {
    value: "rejectedOrderIssues",
    color: "#34A853",
    iconKey: "canelCircleIcon",
  },
  6: {
    value: "canceledOrderIssues",
    color: "#D71314",
    iconKey: "packageWithXIcon",
  },
  7: {
    value: "deliveryFailureOrder",
    color: "#FFB4A7",
    iconKey: "deliveryFailureOrder",
  },
});

// export const IssueTypeEnum = Object.freeze({
//   0: { value: "pendingOrder", color: "#D9880E" }, //prefeeredPickUpDate- start
//   1: { value: "delayedDelivery", color: "#FF4500" }, // prefeeredDeliveryDate - end
//   2: { value: "delayedPickup", color: "#1E90FF" }, //prefeeredPickUpDate- start
//   3: { value: "pendingRescheduledOrder", color: "#91cfde" }, //prefeeredPickUpDate- start
//   4: { value: "driverChangeRequest", color: "#f8b0d5" }, // will navigate somewhere else later data is not coming from back yet// prefeeredPickUpDate- start
//   5: { value: "rejectedOrder", color: "#FFD700" }, //prefeeredPickUpDate- start
//   6: { value: "canceledOrder", color: "#D71314" }, //prefeeredPickUpDate- start
//   7: { value: "deliveryFailureOrder", color: "#FFB4A7" }, //prefeeredPickUpDate- start
// }); // cycle time = modificationDate - now

//CustomerManagement
export const RegistrationStatusEnum = Object.freeze({
  registered: 1,
  pending: 2,
  pendingForApproval: 3,
  active: 4,
});

export const REFETCH_INTERVAL_TIME = 30000;

export const orderStatusCard = Object.freeze({
  all: 0,
  draft: 1,
  incompleteData: 2,
  awaitingSelection: 3,
  pendingPickup: 4,
  pickUpStarted: 5,
  arrivedAtPickup: 6,
  orderCollected: 7,
  orderOutForDelivery: 8,
  arrivedAtDropOff: 9,
  delivered: 10,
  cancelled: 11,
  rejected: 12,
  onHold: 13,
  rescheduled: 14,
  returned: 15,
  failed: 16,
  requestDriverChange: 17,
  driverChangeApproved: 18,
});

export const OrderTypeEnum = Object.freeze({
  regular: 1,
  expedited: 2,
});

export const PricingOptionTypeEnum = Object.freeze({
  PerDelivery: 1,
  PerDistance: 2,
});

export const DriverTypeEnum = Object.freeze({
  regular: 1,
  expedited: 2,
});
